// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"119b081e","897":"4171fa6d"}[chunkId] + ".chunk.js";
};